// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"04a8b1051d11574c5d36","522":"ef40f40f7b2ec60101ee"}[chunkId] + ".js";
};